export default __webpack_public_path__ + "static/media/20th.4edf7394.png";